// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items/{itemKey}/bom.
 * Redirects to /catalog/items/{itemKey}/bom.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/$itemKey/bom')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/catalog/items/$itemKey/bom',
      params: { itemKey: params.itemKey },
      search: true,
    });
  },
});
